/**
 * Branded loading spinner. Used as the Suspense fallback for lazy routes and
 * available for any page's loading state.
 */
export default function Loader ({ label = 'Loading…', fullScreen = true }) {
  const wrap = fullScreen
    ? 'min-h-[60vh] flex items-center justify-center'
    : 'flex items-center justify-center py-10'
  return (
    <div className={wrap} role='status' aria-live='polite'>
      <div className='flex flex-col items-center gap-3'>
        <div className='w-10 h-10 rounded-full border-4 border-[#065f2a] border-t-transparent animate-spin' />
        <span className='text-sm text-gray-500'>{label}</span>
      </div>
    </div>
  )
}
